import cardStatus from './CardManagementStatus';
import { Colors } from '@/components/common';

const cardStatusString = {
  SolicitadaBanco: 'Solicitada al Banco',
  RecibidaSAEE: 'Recibida en SAEE',
  RecibidaSAEENoPin: 'Recibida en SAEE No PIN',
  Entregada: 'Entregada',
  Cancelada: 'Cancelada',
  Nuevo: 'Nuevo',
  RecibidaSAEENoTarjeta: 'Recibida en SAEE No Tarjeta',
  EntregadaCSEE: 'Entregada al CSEE',
};

const getCardStatusColor = (statusId, isHexColor) => {
  switch (statusId) {
    case cardStatus.Nuevo:
    case cardStatus.SolicitadaBanco:
      return isHexColor ? '#f8ea80' : Colors.YELLOW;
    case cardStatus.Entregada:
    case cardStatus.EntregadaCSEE:
      return isHexColor ? '#a4e5b2' : Colors.GREEN_LIGHT;
    case cardStatus.RecibidaSAEE:
    case cardStatus.RecibidaSAEENoPin:
    case cardStatus.RecibidaSAEENoTarjeta:
      return isHexColor ? '#f8b184' : Colors.ORANGE_LIGHT;
    case cardStatus.Cancelada:
      return isHexColor ? '#d5b89a' : Colors.BROWN;
    default:
      return isHexColor ? '#f8ea80' : Colors.YELLOW;
  }
};

export { cardStatus, cardStatusString, getCardStatusColor };
